// Font Awesome's global icon registry. Anything that names an icon by string instead of importing
// the icon object resolves it here: dom.watch() below rewrites <i class="fas fa-..."> tags into
// SVGs, and FontAwesomeIcon resolves a ['far', name] pair. Both only find what library.add() got.
//
// Most app icons live in app/data/app_icons.js, which imports its icon objects directly and needs
// nothing from here. Three things do need this registry:
//   1. Buefy. main.js configures it with defaultIconPack 'fas' and no icon component, so it
//      renders <i class="fas fa-..."> from its own templates. Of the Buefy components this app
//      uses, only b-input (status icons), b-numberinput (plus/minus), b-tag (close-icon) and
//      b-icon render one. b-checkbox, b-switch, b-radio, b-upload, b-loading and b-modal draw
//      theirs in CSS. Buefy translates some names on the way (information -> info-circle,
//      alert-circle -> exclamation-circle, menu-down -> caret-down), so the names below are the
//      translated ones. EM-719 removes Buefy, and with it most of this file.
//   2. The design system's AppIcon (shared_components/AppIcon.vue). It hands FontAwesomeIcon a
//      ['far', name] pair, which only resolves for a registered icon. AppMessage's info icon is
//      the first one the app renders; the other severities are still Storybook-only.
//   3. IntegrationWarning.vue, which renders integrations.icon_class straight from the API.
//      Supervisors edit that field as free text; today it only ever holds 'fas fa-rotate' or
//      'fab fa-salesforce'. A value outside this list renders nothing, so add it here.
import { dom, library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDown,
  faCaretDown,
  faCaretUp,
  faCheck,
  faEllipsisVertical,
  faExclamationCircle,
  faExclamationTriangle,
  faEyeSlash,
  faInfoCircle,
  faMinus,
  faPlus,
  faRotate,
  faCircleCheck as fasCircleCheck,
  faTimesCircle,
  faTrashCan,
  faUpload,
} from '@fortawesome/free-solid-svg-icons';
import {
  faAnglesRight as farAnglesRight,
  faArrowTrendDown as farArrowTrendDown,
  faArrowTrendUp as farArrowTrendUp,
  faArrowUpRightFromSquare as farArrowUpRightFromSquare,
  faBuilding as farBuilding,
  faCalendarDays as farCalendarDays,
  faChartColumn as farChartColumn,
  faCheck as farCheck,
  faChevronDown as farChevronDown,
  faCircleCheck as farCircleCheck,
  faCircleExclamation as farCircleExclamation,
  faCircleInfo as farCircleInfo,
  faClockRotateLeft as farClockRotateLeft,
  faComments as farComments,
  faCreditCard as farCreditCard,
  faDownload as farDownload,
  faEllipsisVertical as farEllipsisVertical,
  faEye as farEye,
  faMinus as farMinus,
  faPaperPlane as farPaperPlane,
  faPen as farPen,
  faPlus as farPlus,
  faSpinner as farSpinner,
  faStars as farStars,
  faTrashCan as farTrashCan,
  faTriangleExclamation as farTriangleExclamation,
  faUsers as farUsers,
  faXmark as farXmark,
} from '@fortawesome/pro-regular-svg-icons';
import { faSalesforce } from '@fortawesome/free-brands-svg-icons';

library.add(
  faAngleDown,
  faCaretDown,
  faCaretUp,
  faCheck,
  fasCircleCheck,
  faEllipsisVertical,
  faExclamationCircle,
  faExclamationTriangle,
  faEyeSlash,
  faInfoCircle,
  faMinus,
  faPlus,
  faRotate,
  faSalesforce,
  farAnglesRight,
  farArrowTrendDown,
  farArrowTrendUp,
  farArrowUpRightFromSquare,
  farBuilding,
  farCalendarDays,
  farChartColumn,
  farCheck,
  farChevronDown,
  farCircleCheck,
  farCircleExclamation,
  farCircleInfo,
  farClockRotateLeft,
  farComments,
  farCreditCard,
  farDownload,
  farEllipsisVertical,
  farEye,
  farMinus,
  farPaperPlane,
  farPen,
  farPlus,
  farSpinner,
  farStars,
  farTrashCan,
  farTriangleExclamation,
  farUsers,
  farXmark,
  faTimesCircle,
  faTrashCan,
  faUpload,
);

dom.watch();
